// Lazy, memoised loader for the `qrcode` library (~200 KiB with its deps).
// Kept out of the static import graph so QR generator routes don't ship it in
// their initial bundle — it loads once, on first render, and is reused after.
type QR = typeof import("qrcode");

let promise: Promise<QR> | null = null;

export function loadQRCode(): Promise<QR> {
  if (!promise) {
    promise = import("qrcode").then((m) => (m as { default?: QR }).default ?? m);
  }
  return promise;
}
